import { useEffect } from "react";

import { useTypedQuery } from "hooks";
import { useLeadsCarsFilters } from "modules/LeadsDashboard/Leads/CarsLeads/hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useLeadsCarsQuery = () => {
  const carsFilters = useLeadsCarsFilters();

  const query = useTypedQuery({
    queryKey: LeadsQueryKeys.listCars,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, carsFilters, baseUrl)).data,
    enabled: false
  });

  useEffect(() => {
    const hasDealerLocationSelected = carsFilters.location_ids.length > 0 || carsFilters.dealer_ids.length > 0;
    const hasDateRangeSelected = carsFilters.date_from && carsFilters.date_to;

    if (hasDealerLocationSelected && Boolean(hasDateRangeSelected)) query.refetch();
  }, [carsFilters]);

  return query;
};
